import { API_URL } from "../Config";
import { PageResult } from "../Pagination";

export interface IIncidentUpdateRequest {
  incidentupdaterequestid: string;
  reference: string;
  status: string;
  request: string;
  licenceid: string;
  incidentid: string;
  datesubmitted: string;
  duedate: string;
}

export interface IIncidentUpdateRequestsList extends PageResult {
  list: IIncidentUpdateRequest[];
}

export const GetIncidentUpdateRequestsFetchUrl = (
  incidentId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;
  var filterParams = "";
  if (searchText && searchText.length > 0) {
    filterParams += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Incident/incidentupdaterequestlist?incident_id=${incidentId}${filterParams}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/incident-update-requests`;
  }

  return url;
};
